import { Component } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TappedQtyDialogComponent } from './tapped-qty/tapped-qty-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ContainerTapService } from '../services/container-tap/container-tap.service';
import { successMessage } from '../constants';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-row-checkbox-tap',
  template: `
  <ng-container *ngIf="isCheckBox && namcValue !== '21' && params.data[params.colDef.field]; else plainValue">
  <div class="checkbox-cell" [ngStyle]="cellStyle" (click)="openDialog()">
    <span class="span-cell">
      {{ params.data[params.colDef.field] }}
    </span>
  </div>
</ng-container>

<ng-template #plainValue>
  <div class="span-cell" [ngStyle]="getCellStyle()">
    <span class="span-cell">
      {{ params.data[params.colDef.field] }}
    </span>
  </div>
</ng-template> `,
  styles: [`
    .checkbox-cell {
      display: flex;
      align-items: center;
    }
    .span-cell {
      margin-left: 1rem;
    }
  `]
})
export class RowCheckboxTapComponent implements ICellRendererAngularComp {
  public params: any;
  isCheckBox = false;
  cellStyle: { cursor?: string; color?: string; textDecoration?: string,textDecorationColor?:string } = {};
  modalComponent = 'modal-component';
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  userRole = localStorage.getItem('UserRoles');
  user = localStorage.getItem('workdayId');

  constructor(
    private readonly dialog: MatDialog,
    private readonly containerTapService: ContainerTapService,
    private readonly spinner: NgxSpinnerService
  ) { }

  agInit(params: any): void {
    this.params = params;
    const data = params.data;
    console.log("data",data);
    const moduleNumber = data.module_number;
    const fieldName = params.colDef.field; // e.g., 'kanban_0004'
    this.isCheckBox = false;
    this.cellStyle = {};

    // Check if the field is like "kanban_0004"
    const match = fieldName.match(/^kanban_(\d+)$/);
    if (match && moduleNumber !== 'ALL') {
      const id = match[1]; // e.g., "0004"
      const statusField = `kanban_status_${id}`;
      const statusValue = data[statusField];//
      const kanbanPieces = `kanban_${id}`
      const kanbanPiecesvalue =data[kanbanPieces]
      const isZero= kanbanPiecesvalue === "0(0)" 

      // Final condition: status is null or empty string
      const isStatusEmpty = statusValue === null || statusValue?.trim() === '';

      if (isZero) {
        this.isCheckBox = false;
        this.cellStyle = {}; // Clear any previous styles

      } else if (isStatusEmpty) {
        this.isCheckBox = true;
        this.cellStyle = {
          cursor: 'pointer',
          color: '#2688DA',
          textDecoration: 'underline'
        }}
      else {
        this.isCheckBox = false;
        this.cellStyle = {
          textDecoration: 'line-through',
          textDecorationColor: '#808080'        };
      }
    }
  }

  refresh(params: any): boolean {
    return false;
  }

  openDialog(): void {
    if (this.dialog.openDialogs.length > 0) return;

    const fieldName = this.params.colDef.field;
    const kanbanData = this.params.data;
    let dynamicValue = '';
    let parts: string[] = [];

    if (fieldName && fieldName.startsWith('kanban_')) {
      dynamicValue = fieldName.split('_')[1];
      const value = kanbanData[fieldName];

      if (typeof value === 'string' && value.includes('(') && value.includes(')')) {
        parts = value.split(/[\(\)]/);
      } else if (typeof value === 'string') {
        parts = [value, ''];
      }
    }

    if (kanbanData.module_number !== 'ALL') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = this.modalComponent;
      dialogConfig.width = '650px';
      dialogConfig.maxHeight = '450px';
      dialogConfig.data = {
        dockList: localStorage.getItem('dock'),
        business_entity: kanbanData.business_entity,
        container_renban: kanbanData.container_renban,
        module_number: kanbanData.module_number,
        planned_stocking_datetime: kanbanData.planned_stocking_datetime,
        kanban: dynamicValue,
        lots: parts[0] || '',
        pieces: parts[1] || '',
        mode: 'update',
      };

      const dialogRef = this.dialog.open(TappedQtyDialogComponent, dialogConfig);

      const addGetResponse = dialogRef.componentInstance?.editTapedQtyEventEmitter?.subscribe({
        next: (res) => {
          const data1 = {
            business_entity: this.namcValue,
            workid: this.user,
            user_role: this.userRole,
            userid: this.userName,
            isTap: res.stockingDate === '',
            noSchedule: res.scheduleData,
            data: [
              {
                userid: this.userName,
                dock: res.dock,
                tap_flag: res.stockingDate === '' ? 'Y' : 'N',
                mod_qty_received: res.noOfPieces,
                tapped_qty: res.noOfPieces,
                part_status: res.stockingDate === '' ? 'FULLY TAPPED' : '',
                kanban: res.kanban,
                container_renban: res.container,
                module_number: res.moduleNumber,
                old_tapped_qty: '',
                tap_history: '',
                isTap: res.stockingDate === '',
                stocked_date: res.stockingDate === '' ? 'MM/DD/YYYY' : res.stockingDate,
                stocked_datetime: res.stockingDate + ' ' + res.stockingTime,
              }
            ]
          };

          this.containerTapService?.updateContap(data1)?.subscribe({
            next: (response) => {
              const inserted = response.body?.insertedRows ?? 0;
              const updated = response.body?.updatedRows ?? 0;
              const scheduleTap = response.body?.updatedRowsTap ?? 0;

              const parent = this.params.context.componentParent;
              if ((inserted >= 1 && updated >= 1) || (updated >= 1 && scheduleTap >= 1)) {
                parent.selectedContainerFrom.container_renban = res.container;
                parent.selectedContainerTo.container_renban = res.container;
                // parent.selectedModule = res.moduleNumber;
                parent.onSearch(0);
                parent.selectedContainerFrom = [];
                parent.selectedContainerTo = [];
                parent.selectedModule = '';
              } else {
                parent.onSearch(0);


              }
              parent.successMessage =
                ((inserted >= 1 && updated >= 1) || (updated >= 1 && scheduleTap >= 1))
                  ? successMessage.tapUpdated
                  : successMessage.scheduleUpdated;

              window.scroll(0, 0);
            }
          });
        }
      });

      dialogRef.afterClosed().subscribe(() => {
        addGetResponse?.unsubscribe();
      });
    }
  }

getCellStyle() {
  return {
    ...this.cellStyle,
    color:
      this.namcValue === '21' && this.cellStyle.color === '#2688DA'
        ? 'black'
        : this.cellStyle.color,
    textDecoration:
      this.namcValue === '21' && this.cellStyle.textDecoration === 'underline'
        ? 'none'
        : this.cellStyle.textDecoration
  };
}}
